import {  Message } from '../../models/message';
import { HttpClient } from '@angular/common/http';
import { CacheService } from '../cache';
import { ResourceService } from './resource';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MessageService extends ResourceService<Message> {

  /**
    * Creates an instance of the MessageService 
    *
    * @param {HttpClient} http Injected instance of HttpClient
    * @param {CacheService} cache Injected instance of CacheService
  */
  constructor(
    protected http: HttpClient,
    protected cache: CacheService
  ) {
    super(http, cache, 'channels');
  }

   /**
    * Sends a POST request to the /channels/messages endpoint
    * @remarks
    * to send messages.
    *
    * @param {any} payload Body sent to the endpoint 
    * @returns {Observable} Returns an observable 
  */
  createMessage(payload: any) {
    const url = `${this.endpoint}/messages`;
    return this.http.post(url, payload)
      .pipe(map((resp: any) => {
        this.cache.remove(url);
        this.cache.remove(this.endpoint);
        return resp;
      }));
  }

  /**
    * Sends a GET request to the /channels/messages endpoint
    * @remarks
    * to fetch messages in a single channel.
    *
    * @param {string} channelId The unique identifier used to fetch a channel 
    * @returns {Observable} Returns an observable 
  */
  fetchMessages(channelId: string) {
    return this.http.get(`${this.endpoint}/messages/${channelId}`)
  }

  /**
    * Sends a GET request to the /channels endpoint
    * @remarks
    * to fetch list of channels.
    *
    * @returns {Observable} Returns an observable 
  */
  fetchChannels() {
    return this.http.get(`${this.endpoint}`);
  }

  /**
    * Sends a GET request to the /channels/:userId endpoint
    * @remarks
    * to create a new channel with the selected user.
    *
    * @param {string} userId The unique identifier used to create a channel 
    * @returns {Observable} Returns an observable 
  */
  createChannel(userId: string) {
    const url = `${this.endpoint}/${userId}`
    return this.http.get(url)
      .pipe(map((resp: any) => {
        this.cache.remove(url);
        this.cache.remove(this.endpoint);
        return resp;
      }));
  }


}
